export default {
  NAMESPACE: 'search/history'
}
